import { render } from "./EmptyEquipment.vue?vue&type=template&id=796c0eda&scoped=true"
import script from "./EmptyEquipment.vue?vue&type=script&lang=js"
export * from "./EmptyEquipment.vue?vue&type=script&lang=js"

import "./EmptyEquipment.vue?vue&type=style&index=0&id=796c0eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796c0eda"]])

export default __exports__